// extracted by mini-css-extract-plugin
export default {"filename":"FileNameDisplay_filename__v3xbS"};